import React, { FC } from 'react';
import InputField from '@ingka/input-field';
import { NumberFormatBase } from 'react-number-format';
import { EUR } from '../../constants';
import { formatSignedNumber, removeSignedFormatting } from './utils';

type SignedKeurInputProps = {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
};

const SignedKeurInput: FC<SignedKeurInputProps> = ({
  id,
  label,
  value,
  onChange,
}) => (
  <NumberFormatBase
    customInput={InputField}
    type="text"
    inputMode="numeric"
    style={{ width: '100%' }}
    id={id}
    label={label}
    suffixLabel={`K${EUR}`}
    value={value}
    valueIsNumericString
    format={formatSignedNumber}
    removeFormatting={removeSignedFormatting}
    onValueChange={({ value: numString }) => onChange(numString)}
  />
);

export default SignedKeurInput;
